/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useSelector } from 'react-redux';
import { isApplicationLoading } from './application.slice';

/* Auth hook */
export function useApplication() {
  const loading = useSelector(isApplicationLoading);

  return {
    loading,
  };
}
